import { CustomStorageSettings } from '../../../api/configurations/customStorage/types';

type TransformedObject = {
  [key: string]: string | number;
};

type InputObject = { [key: string]: string | number | boolean | null };

export const prefixesShowMap = ['login_url', 'registration_url', 'social_url'];
export const prefixes = [
  'login_url',
  'registration_url',
  'social_url',
  'password_reset_url',
  'email_change_url',
  'passwordless_registration_url',
  'refresh_token_url'
];

export const transformArray = (array: CustomStorageSettings[]): TransformedObject => {
  return array.reduce((result: TransformedObject, item: CustomStorageSettings) => {
    const entries = Object.entries(item).map(([key, value]) => [`${item.type}_${key}`, value]);
    return { ...result, ...Object.fromEntries(entries) };
  }, {});
};

const getFinalValue = (
  key: string,
  value: string | number | boolean | null
): string | number | boolean | null => {
  if (key === 'lifetime') {
    return value === '' || value === null ? 0 : Number(value);
  }

  return value === '' || value === null ? null : value;
};

export const extractKeyValuePairs = (
  input: InputObject
): { [key: string]: string | number | boolean | null }[] => {
  const regex = new RegExp(`^(${prefixes.join('|')})_`);
  const inputToggleValue = {
    ...input,
    registration_url_linking_server_custom_id: input.social_url_linking_server_custom_id,
    login_url_linking_server_custom_id: input.social_url_linking_server_custom_id
  };
  const groupedObjects = Object.entries(inputToggleValue).reduce((acc, [key, value]) => {
    const matched = key.match(regex);
    if (matched) {
      const prefix = matched[1];
      const newKey = key.replace(`${prefix}_`, '');

      const finalValue = getFinalValue(newKey, value); // Use the helper function

      acc[prefix] = {
        ...(acc[prefix] || {}),
        [newKey]: finalValue,
        type: prefix
      };
    }
    return acc;
  }, {} as { [key: string]: { [key: string]: string | number | boolean | null } });
  return Object.values(groupedObjects);
};
